(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veylo-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veylo-gallery')) {
 customElements.define('veylo-gallery', class extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;
   this.ready=true;
   this.slides=[...this.querySelectorAll('.va-gallery-slide')];
   this.thumbs=[...this.querySelectorAll('.va-gallery-thumb')];
   this.current=0;
   this.dialog=this.querySelector('dialog');
   this.addEventListener('click',e=>{
    const thumb=e.target.closest('[data-index]');
    const step=e.target.closest('[data-step]');
    if(thumb)this.select(Number(thumb.dataset.index));
    if(step)this.select(this.current+Number(step.dataset.step));
    if(e.target.closest('.va-gallery-zoom')){
     const img=this.slides[this.current].querySelector('img').cloneNode(true);
     img.loading='eager';
     this.querySelector('.va-gallery-enlarged').replaceChildren(img);
     this.dialog.showModal();
    }
    if(e.target.closest('.va-gallery-close')||e.target===this.dialog)this.dialog.close();
   });
   this.querySelector('.va-gallery-strip').addEventListener('keydown',e=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
    e.preventDefault();
    const idx=e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.current+(e.key==='ArrowRight'?1:-1);
    this.select(idx);this.thumbs[this.current].focus();
   });
   const stage=this.querySelector('.va-gallery-stage');
   let startX=null;
   stage.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});
   stage.addEventListener('touchend',e=>{
    if(startX===null)return;
    const diff=e.changedTouches[0].clientX-startX;
    if(Math.abs(diff)>60)this.select(this.current+(diff<0?1:-1));
    startX=null;
   },{passive:true});
  }
  select(index){
   this.current=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{slide.hidden=i!==this.current;});
   this.thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===this.current)));
   const count=this.querySelector('.va-gallery-count');
   if(count)count.textContent=String(this.current+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
   this.thumbs[this.current].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
